module.exports = __webpack_public_path__ + "static/media/appointment_slider_phone2.fd67a699.png";